export default {
  CODE: 'code',
  ENGLISH: 'english',
  ESTONIAN: 'estonian',
  EXPORT: 'export',
};
